import { RootState } from '../../store/types'

export const filterAndVisualizationSelector = (state: RootState) => state.app.filterAndVisualization
